export const userStatusValues = ['active', 'disabled'] as const;
export type UserStatus = (typeof userStatusValues)[number];

export interface UserDto {
  id: string; // UUID
  email: string;
  status: UserStatus;
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
}
